export const getLogoURL = (name) => {
  return (
    "https://logo.clearbit.com/" + name.replace(/\s/g, "") + ".com?size=80"
  );
};
